module.exports = __webpack_public_path__ + "7e356d6169e0b13d7c00b43817aedca1.svg";